import React, {useState} from 'react';
import axios from 'axios';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { StyledMember, StyledPanel } from '../stylesheets/styles';
import { API_URL } from '../common/constants';
import classNames from "classnames";
import BgComponent from '../components/BgComponent';

const getParameterByName = (name, url = window.location.href) => {
  name = name.replace(/[\[\]]/g, '\\$&');
  const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
  const results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

const ForgetPasswordForm = () => {
  const { 
    register, 
    handleSubmit, 
    watch,
    setValue,
    setError, 
    formState: { errors, isSubmitting }
  } = useForm({
    defaultValues: {
      Account: '',
      ClientUrl: window.location.href.replace('ForgetPwdTest', 'ForgetPwdSend')
    }
  });
  const [successSend, setSuccessSend] = useState(false);
  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`${API_URL}/api/member/forgetpwd`, data, {
        headers: { 'Content-Type': 'application/json' }
      });

      const { isSuccess, message } = response.data;
      if (isSuccess) {
        alert(message);
        setError("root", {
          isSuccess: isSuccess,
          message: message,
        });
        setSuccessSend(true);
      }
    } catch (error) {
      alert(error.responseJSON.message);
      console.error('Error submitting forget password:', error);
    }
  };

  console.log('errors', errors);

  return (
    <>
      { successSend ? 
        <ForgetPwdSend /> :
        <StyledMember className='register'>
          <div className='member-wrap'>
            <Container>
              <Row className="justify-content-md-center">
                <Col xl="7" lg="10" md="12">
                  <StyledPanel>
                    <div className="hgroup">
                      <h1 className="text-center">忘記密碼</h1>
                    </div>
                    <Form noValidate name="frmForgetPwd" action="" onSubmit={handleSubmit(onSubmit)}>
                      <div className="form-group mb-3">
                        <label htmlFor="Account" className="form-label">信箱/手機門號</label>
                        <input {...register("Account")} type="text" name="Account"  placeholder='信箱/手機門號' className="form-control" id="Email" />
                      </div>
                      <div className="form-button pt-4">
                        <Button disabled={isSubmitting} size="lg" variant="dark" className="w-100" type="submit">
                          { isSubmitting ? '處理中...' : '送出' }
                        </Button>
                        {errors.root && <p className={classNames("form-helper mt-2", errors.root.isSuccess ? 'text-success' : 'text-danger')}>{errors.root.message}</p>}
                        <div className="d-flex align-items-center justify-content-between pt-3">
                          <Link to="/login" className="btn btn-link p-0">返回登入</Link>
                          <Link to="/register" className="btn btn-link p-0">註冊新會員</Link>
                        </div>
                      </div>
                    </Form>
                  </StyledPanel>
                </Col>
              </Row>
            </Container>
            <BgComponent/>
          </div>
        </StyledMember>
      }
    </>
  );
};

const ForgetPwdSend = () => {
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">忘記密碼</h1>
                </div>
                <p>已寄送重設密碼信件至您的信箱，請查收。</p>
                <div className="form-button pt-4">
                  <Link to="/login" className="btn btn-dark w-100">返回登入</Link>
                </div>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
}

const ResetPasswordForm = () => {
  const { register, handleSubmit, setError, watch, formState: { errors, isSubmitting } } = useForm({
    defaultValues: {
      Password: '',
      ClientUrl: window.location.href.replace('ForgetPwdTest', 'ForgetPwdSend')
    }
  });
  const navigate = useNavigate();

  const watchValue = watch();
  const onSubmit = async (data) => {
    try {
      const response = await axios.post(`${API_URL}/api/member/resetpwd`, {
        Pwd: data.Password,
        Q: getParameterByName('q')
      }, {
        headers: { 'Content-Type': 'application/json' }
      });
      const { isSuccess, message } = response.data;
      if (isSuccess) {
        alert(message);
        localStorage.removeItem('token');
        navigate('/');
      }
      setError("root", {
        isSuccess: isSuccess,
        message: message,
      });
    } catch (error) {
      alert(error.response?.data?.message || 'Error submitting reset password');
      console.error('Error submitting reset password:', error);
    }
  };

  console.log('errors', errors);
  return (
    <StyledMember className='register'>
      <div className='member-wrap'>
        <Container>
          <Row className="justify-content-md-center">
            <Col xl="7" lg="10" md="12">
              <StyledPanel>
                <div className="hgroup">
                  <h1 className="text-center">重設密碼</h1>
                </div>
                <Form noValidate onSubmit={handleSubmit(onSubmit)} name="frmResetPwd">
                <div className="form-group mb-3">
                    <label htmlFor="password" className="form-label">密碼*</label>
                    <input 
                      {...register('Password', { 
                        required: true, 
                        minLength: {
                          value: 8,
                          message: '密碼至少8個字元'
                        }
                      })} 
                      type="password"
                      id="Password" 
                      className={`form-control ${errors.Password ? "is-invalid" : ""}`}
                      placeholder="請輸入新密碼"
                    />
                    {errors.Password && <p className="form-helper text-danger">{errors.Password.message}</p>}
                  </div>
                  <div className="form-group mb-3">
                    <label htmlFor="confirmPassword" className="form-label">再次輸入密碼*</label>
                    <input 
                      {...register("confirmPassword", {
                        required: "確認密碼為必填欄位",
                        validate: (value) =>
                          value === watchValue.Password || "密碼不一致",
                      })}
                      type="password"
                      id="confirmPassword" 
                      className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                      placeholder="再次確認密碼"
                    />
                    {errors.confirmPassword && (
                      <p className="form-helper text-danger">{errors.confirmPassword.message}</p>
                    )}
                  </div>   
                  <div className="form-button pt-4">
                    <Button disabled={isSubmitting} size="lg" variant="dark" className="w-100" type="submit">
                      { isSubmitting ? '處理中...' : '重設密碼' }
                    </Button>
                    {errors.root && <p className={classNames("form-helper mt-2", errors.root.isSuccess ? 'text-success' : 'text-danger')}>{errors.root.message}</p>}
                  </div>
                </Form>
              </StyledPanel>
            </Col>
          </Row>
        </Container>
        <BgComponent/>
      </div>
    </StyledMember>
  );
};

const ForgetPassword = () => {
  const location = useLocation();
  const q = getParameterByName('q');
  return (
    <>
      { q ? <ResetPasswordForm /> : <ForgetPasswordForm /> }
    </>
  );
};

export default ForgetPassword;